import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32520086"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold mb-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-4" }
const _hoisted_5 = { class: "fw-bold ps-2 fs-7 mb-3" }
const _hoisted_6 = { class: "col-lg-8" }
const _hoisted_7 = { class: "fw-bold mb-3 fs-7 mt-5 mt-xxl-0" }
const _hoisted_8 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_9 = { class: "w-max-content col-lg-3 mt-2" }
const _hoisted_10 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_11 = { class: "col-lg-8" }
const _hoisted_12 = { class: "form-check" }
const _hoisted_13 = ["for"]
const _hoisted_14 = ["name", "id", "value"]
const _hoisted_15 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_16 = { class: "w-max-content col-lg-3 mt-2" }
const _hoisted_17 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_18 = { class: "col-lg-8 mt-2" }
const _hoisted_19 = { class: "form-check me-5" }
const _hoisted_20 = ["for"]
const _hoisted_21 = ["id"]
const _hoisted_22 = { class: "form-check" }
const _hoisted_23 = ["for"]
const _hoisted_24 = ["id"]
const _hoisted_25 = { class: "row mx-0 px-0 my-4 d-flex justify-content-center" }
const _hoisted_26 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_27 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }

import { computed, onMounted, ref, watch, watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { numberWithCommas } from '@/constants/common.ts'
import ChooseUser from '@/components/choose-user/index.vue'
import Button from '@/components/button/index.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import ModalConfirm from './components/ModalConfirm.vue'
import ModalComplete from './components/ModalComplete.vue'

import { translate } from '@/languages/i18n'
import { COMMUNITY_ALUMNUS_STORE, COMMUNITY_USERS_STORE, CONVERSATIONS_STORE } from '@/store/constants'
import useVuelidate from '@vuelidate/core'

import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import Status from '@/components/status/index.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()

const listFlags = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_LIST_MANAGING_FLAGS])
const selectedUsers = computed(() => store.getters[COMMUNITY_USERS_STORE.GETTERS.USER_SELECTED])

onMounted(() => {
  store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_LIST_MANAGING_FLAGS, route.params?.id)
})

const formData = ref({
  management_flag: listFlags.value[0]?.id,
  settingFlag: 'add',
})

const listUserFailed = ref<any[]>([])

const rules = computed(() => {
  return {
    management_flag: {
      requiredSelect: function (value) {
        if (value) return true
      },
    },
    settingFlag: {
      requiredSelect: function (value) {
        if (value) return true
      },
    },
  }
})

const v$ = useVuelidate(rules, formData)

const onSubmit = (): void => {
  v$.value.$touch()
  if (v$.value.$invalid) {
    return
  }
}

const getListUserFailed = (value: any[]): void => {
  listUserFailed.value = value
}

const handleTransitCommunityUsers = () => {
  // 2022/11/02 TienNV Fix bug selected user disappears when back previous page  UAT#4500: OE53(Ph2-R20221104)
  const payload = {
    typeData: 'employee',
    type: 'checkAll',
    data: selectedUsers.value,
  }
  store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, payload)
  // 2022/11/08 TienNV Fix bug selected user disappears when back previous page  UAT#4500: OE53(Ph2-R20221111)
  router.go(-1)
}

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('OE30userManagement'),
    to: '',
    active: false,
  },
  {
    content: `${translate('OE10listUser')}（${translate('CD40enrolledUser')}）`,
    to: `/community/communities/${route.params?.id}/community-users?management_no=desc`,
    active: false,
  },
  {
    content: translate('OE53titleManagementFlag'),
    to: '',
    active: true,
  },
]

watchEffect(() => {
  if (!selectedUsers.value?.length) {
    router.replace(`/community/communities/${route.params?.id}/community-users?management_no=desc`)
  }
})

watch(
  () => listFlags.value,
  () => {
    formData.value = {
      management_flag: listFlags.value[0]?.id || '',
      settingFlag: 'add',
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('OE53titleManagementFlag')), 1),
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(numberWithCommas)(_unref(selectedUsers).length)) + _toDisplayString(_unref(translate)('selectingUserItems')), 1),
            _createVNode(ChooseUser, {
              data: _unref(selectedUsers),
              className: 'wrapper-message',
              disabled: true
            }, null, 8, ["data"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h6", _hoisted_7, _toDisplayString(_unref(translate)('OE53updateUserSelected')), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(translate)('OE53updateManagementFlag')), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listFlags), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass([_unref(v$).management_flag.$error ? 'is-invalid' : '']),
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("label", {
                        class: "form-check-label cursor-pointer",
                        for: `flag${item?.name + item?.id}`
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input cursor-pointer",
                          type: "radio",
                          name: `flag${item?.name + item?.id}`,
                          id: `flag${item?.name + item?.id}`,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.management_flag) = $event)),
                          value: item?.id
                        }, null, 8, _hoisted_14), [
                          [_vModelRadio, formData.value.management_flag]
                        ]),
                        _createTextVNode(" " + _toDisplayString(item?.name), 1)
                      ], 8, _hoisted_13)
                    ])
                  ], 2))
                }), 128)),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('OE53updateManagementFlag'),
                  validator: _unref(v$).management_flag.$errors[0]?.$validator
                }, null, 8, ["title", "validator"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(translate)('OE53flagSetting')), 1),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", {
                  class: _normalizeClass(['d-flex', _unref(v$).settingFlag.$error ? 'is-invalid' : ''])
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: _ctx.addFlag
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "managementFlag",
                        id: _ctx.addFlag,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.settingFlag) = $event)),
                        value: 'add'
                      }, null, 8, _hoisted_21), [
                        [_vModelRadio, formData.value.settingFlag]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('OE53flag')), 1)
                    ], 8, _hoisted_20)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: _ctx.removeFlag
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "managementFlag",
                        id: _ctx.removeFlag,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.settingFlag) = $event)),
                        value: 'delete'
                      }, null, 8, _hoisted_24), [
                        [_vModelRadio, formData.value.settingFlag]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('OE53removeFlag')), 1)
                    ], 8, _hoisted_23)
                  ])
                ], 2),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('OE53flagSetting'),
                  validator: _unref(v$).settingFlag.$errors[0]?.$validator
                }, null, 8, ["title", "validator"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(Button, {
                title: _unref(translate)('back'),
                type: 'secondary',
                onClick: handleTransitCommunityUsers
              }, null, 8, ["title"])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(Button, {
                title: _unref(translate)('confirm'),
                type: 'secondary',
                onClick: onSubmit,
                dataBsToggle: !_unref(v$).$invalid ? 'modal' : '',
                dataBsTarget: '#modalConfirm'
              }, null, 8, ["title", "dataBsToggle"])
            ])
          ])
        ])
      ], 32)
    ]),
    _createVNode(ModalConfirm, {
      data: formData.value,
      userSelected: _unref(selectedUsers),
      getListUserFailed: getListUserFailed,
      typeModal: 'user'
    }, null, 8, ["data", "userSelected"])
  ], 64))
}
}

})